/**
 * 门店备注
 */
import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Select, Input } from 'antd';
import intl from 'react-intl-universal';

import ReserveService from '@/api/reserve';
import ContentBlock from '@/components/Reservation/ContentBlock';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { handleStoreRemarkChange } from '@/redux/actions/reservation/checkInExchange';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInExchange';
import { validReverseRemark, ReverseResonCodeQT } from '@/pages/reservation/roomExchange/helper';

import styles from './index.module.scss';

const { Option } = Select;
const { TextArea } = Input;

const stateSelector = (state: ReducerState) => {
  const {
    rentRoomInfos,
    commonInfo,
    rentTimeInfo,
    allRoomList,
    marketPriceList,
    cardEnabled,
  } = state;
  return {
    rentRoomInfos,
    allRoomList,
    commonInfo,
    rentTimeInfo,
    marketPriceList,
    cardEnabled,
  };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  storeRemarkChange: handleStoreRemarkChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

interface IProps {
  // refreshRoomCardCount: () => void;
}

const Index: React.FC<IProps & MapStateProps & MapDispatchProps> = (props) => {
  const { storeRemarkChange } = props;
  const [reasons, setReasons] = useState<any[]>([]);

  const [resonCode, setResonCode] = useState(null);

  // 获取原因
  const getReasonList = async () => {
    let result: any = [];
    try {
      const res = await ReserveService.getDictListByType({
        code: 'ROOM_CHANGE_REASON',
      });

      result =
        (res.data?.list || []).map((item) => {
          return {
            value: item?.dictKey,
            label: item?.dictValue,
          };
        }) || [];
    } catch (_) {
      result = [];
    }
    setReasons(result);
  };

  useEffect(() => {
    getReasonList();
  }, []);

  const reasonChange = (e) => {
    const res = reasons.find((item) => e === item.value);
    if (res) {
      storeRemarkChange({ changeReason: res?.label, changeReasonCode: res?.value });
      setResonCode(res?.value);
    }
  };

  const remarkChange = (e) => {
    storeRemarkChange({ changeDetail: e.target.value ? e.target.value.trim() : '' });
  };

  return (
    <ContentBlock title={intl.get('drawer_exchange_remark_block_title')}>
      <Form className={styles.formWrapper}>
        <Form.Item
          name="changeReason"
          label={intl.get('drawer_exchange_remark_exchange_type_label')}
          rules={[
            {
              required: true,
              message: intl.get('drawer_exchange_remark_exchange_type_placeholder'),
            },
          ]}
        >
          <Select
            style={{ width: '240px' }}
            placeholder={intl.get('app_search_form_option_label_please')}
            onChange={reasonChange}
          >
            {reasons.map((item) => (
              <Option value={item.value} label={item.label} key={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="changeDetail"
          label={intl.get('drawer_exchange_remark_exchange_detail_label')}
          rules={[
            {
              validator: (_, value) => validReverseRemark(_, value, resonCode),
            },
          ]}
        >
          <TextArea
            className={styles.remarkTextarea}
            style={{ width: '400px' }}
            rows={3}
            autoSize
            showCount
            maxLength={1000}
            placeholder={
              resonCode !== ReverseResonCodeQT
                ? intl.get('drawer_exchange_remark_exchange_detail_placeholder_choose_input')
                : intl.get('drawer_exchange_remark_exchange_detail_placeholder')
            }
            onChange={remarkChange}
          />
        </Form.Item>
      </Form>
    </ContentBlock>
  );
};

export default connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
